// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const QmCrudStatus = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  CLOSED: 'CLOSED'
};

const {
  SSCC,
  UserDetails,
  UserProfile,
  Location,
  Printer,
  PackageType,
  QMReason,
  WorkflowStatus,
  QMIssue,
  RemoveItemSSCCHistory,
  ReceiptEventPackageHistory,
  AdminActionHistory,
  TripSheet,
  TransportBookingEvent,
  ReceiptEventSite,
  ReceiptEventPackage,
  ReceiptEventPackageItem,
  QmStatusHistoryEntry,
  QmChangeHistoryEntry,
  QmCommentEntry,
  QmPoLineDetail,
  QmPackageDetail,
  QmRecordResult,
  QmRecordPageResult,
  ReceiveManifestQmMatchResult,
  ManifestPartialReceiptLineStatusResult,
  ManifestPartialReceiptStatusResult,
  QmDashboardSummaryResult,
  QmFeatureFlags,
  QmReasonOption,
  QmClosureCodeOption,
  QmLocationOption,
  QmLocationAdminOption,
  QmSiteInboundLocationOption,
  QmSiteInboundLocationAdminOption,
  QmSiteInboundSiteOption,
  QmSiteInboundSiteAdminOption,
  QmSiteInboundSiteUserRole,
  GetUploadUrlResult,
  QmAttachmentResult,
  ManifestCarrier,
  ManifestAddress,
  ManifestLeg,
  Manifest,
  ManifestSSCC,
  ManifestPackage,
  ManifestInvLineItem,
  TransportBookingLocation
} = initSchema(schema);

export {
  SSCC,
  UserDetails,
  UserProfile,
  Location,
  Printer,
  PackageType,
  QMReason,
  WorkflowStatus,
  QMIssue,
  RemoveItemSSCCHistory,
  ReceiptEventPackageHistory,
  AdminActionHistory,
  TripSheet,
  TransportBookingEvent,
  QmCrudStatus,
  ReceiptEventSite,
  ReceiptEventPackage,
  ReceiptEventPackageItem,
  QmStatusHistoryEntry,
  QmChangeHistoryEntry,
  QmCommentEntry,
  QmPoLineDetail,
  QmPackageDetail,
  QmRecordResult,
  QmRecordPageResult,
  ReceiveManifestQmMatchResult,
  ManifestPartialReceiptLineStatusResult,
  ManifestPartialReceiptStatusResult,
  QmDashboardSummaryResult,
  QmFeatureFlags,
  QmReasonOption,
  QmClosureCodeOption,
  QmLocationOption,
  QmLocationAdminOption,
  QmSiteInboundLocationOption,
  QmSiteInboundLocationAdminOption,
  QmSiteInboundSiteOption,
  QmSiteInboundSiteAdminOption,
  QmSiteInboundSiteUserRole,
  GetUploadUrlResult,
  QmAttachmentResult,
  ManifestCarrier,
  ManifestAddress,
  ManifestLeg,
  Manifest,
  ManifestSSCC,
  ManifestPackage,
  ManifestInvLineItem,
  TransportBookingLocation
};
